import { NavLink, useLocation } from 'react-router-dom';
import { useState } from 'react';

import { SITE, NAV_LINKS } from '@config/siteConfig';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`${styles.header} ${isHome ? styles.transparent : ''}`}
    >
      <nav className={`${styles.nav}`}>
        {/* ---- Brand ---- */}
        <NavLink to="/" className={styles.brand} onClick={closeMenu}>
          Acceuil
        </NavLink>

        {/* ---- Desktop / mobile links ---- */}
        <ul className={`${styles.links} ${menuOpen ? styles.open : ''}`}>
          {NAV_LINKS.map(({ label, path }) => (
            <li key={path}>
              <NavLink
                to={path}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.active : ''}`
                }
                onClick={closeMenu}
              >
                {label}
              </NavLink>
            </li>
          ))}
          <li>
            <NavLink
              to="/contact"
              className={styles.contactBtn}
              onClick={closeMenu}
            >
              Contact
            </NavLink>
          </li>
        </ul>

        {/* ---- Mobile toggle ---- */}
        <button
          className={styles.burger}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span className={styles.burgerLine} />
          <span className={styles.burgerLine} />
          <span className={styles.burgerLine} />
        </button>
      </nav>
    </header>
  );
}
